import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { BackgroundTaskToastComponent } from './shared/components/background-task-toast/background-task-toast.component';
import { AppInitService } from './core/services/app-init/app-init.service';
import { AuthService } from './core/services/auth/auth.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingComponent, BackgroundTaskToastComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'sismet';

  constructor(
    private readonly appInitService: AppInitService,
    private readonly authService: AuthService
  ) { }

  async ngOnInit(): Promise<void> {
    if (environment.enableLogin) {
      try {
        await this.authService.initAuthFlow();
      } catch (err) {
        console.error('Erro na autenticação Azure:', err);
      }
    }
    this.appInitService.initializeApp();
  }
}
